// Import all Bootstrap Packages
import * as bootstrap from 'bootstrap';

// or, specify which plugins you need:
//import { Tooltip, Toast, Popover } from 'bootstrap';

// TODO: Enable Tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// TODO: Enable PopOvers
// $(function () {
//     $('[data-toggle="popover"]').popover({
//         trigger: 'focus'
//     })
// })